import React from 'react';

function CalendarIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      id="CalendarIcon"
      viewBox="0 0 24 20"
      className={className}
    >
      <g id="ic_calendar_24px">
        <path
          id="Shape"
          d="M259.76,255.52h-3.5V255a1.5,1.5,0,1,0-3,0v.5h-8V255a1.5,1.5,0,1,0-3,0v.5h-3.5a1.56,1.56,0,0,0-1.5,1.6v14.7a1.59,1.59,0,0,0,1.5,1.7h21a1.56,1.56,0,0,0,1.5-1.6v-14.8A1.56,1.56,0,0,0,259.76,255.52Zm-5.5-.5a.5.5,0,1,1,1,0v3a.5.5,0,0,1-1,0Zm-11,0a.5.5,0,1,1,1,0v3a.5.5,0,0,1-1,0Zm17,16.9a.56.56,0,0,1-.5.6h-21a.56.56,0,0,1-.5-.6v-14.8a.56.56,0,0,1,.5-.6h3.5V258a1.5,1.5,0,0,0,3,0v-1.5h8V258a1.5,1.5,0,0,0,3,0v-1.5h3.5a.56.56,0,0,1,.5.6Z"
          transform="translate(-237.26 -253.52)"
        />
        <path
          id="Shape-2"
          d="M255.76,267.52h-3a1.5,1.5,0,0,0,0,3h3a1.5,1.5,0,0,0,0-3Zm0,2h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
          transform="translate(-237.26 -253.52)"
        />
      </g>
    </svg>
  );
}

export default CalendarIcon;
